document.querySelectorAll('[data-splitting]').forEach(targetElement => {
    let splitResult = SplitType.create(targetElement, {
        types: 'chars',
        tagName: 'div'
    });

    // Apply --char-index to each character
    splitResult.chars.forEach((char, index) => {
        char.style.setProperty('--char-index', index);
    });
});

document.querySelectorAll(".mm-btn").forEach((button) => {
	button.addEventListener("click", () => {
		button.classList.add("clicked");

		// Supprime la classe après l'animation pour pouvoir la rejouer à chaque clic
		setTimeout(() => {
			button.classList.remove("clicked");
		}, 750); // Doit correspondre à la durée de l'animation CSS (0.35s)
	});
});

/*********************************************************************************************
 * Initialize Lenis for smooth scrolling.
 *
 */
gsap.registerPlugin(ScrollTrigger, CustomEase);

const isMobile = window.innerWidth < 769;

let lenis; // Ajouté en haut du fichier pour la portée globale
let lenisShouldBeStopped = false;

// Disable Lenis when overing div with overflow:scroll
function stopLenis() {
	if (!isMobile) {
		lenisShouldBeStopped = true;
		document.querySelector("html").classList.add("stop-scrolling");
		lenis.destroy();
	}
}

// Fonction appelée quand la souris quitte l'élément
function startLenis() {
	if (!isMobile) {
		lenisShouldBeStopped = false;
		if (lenis) {
			lenis.destroy();
		}
		lenis = new Lenis({
			duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            lerp: 0.06,
            smooth: 2,
            smoothTouch: false,
            touchMultiplier: 2,
            wheelMultiplier: 1,
            infinite: false,
            autoResize: true,
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
            ScrollTrigger.update();
		}

		requestAnimationFrame(raf);

		document.querySelector("html").classList.remove("stop-scrolling");
	}
}

function setupLenis() {
	var elements = document.querySelectorAll(".stop-lenis");
	lenisShouldBeStopped = false;

	elements.forEach(function (element) {
		if (!isMobile) {
			element.addEventListener("mouseenter", stopLenis);
			element.addEventListener("mouseleave", startLenis);
		}
	});
}

if (!isMobile) {
	setupLenis();
}

document.querySelectorAll(".mm-btn").forEach((button) => {
	button.addEventListener("click", () => {
		button.classList.add("clicked");

		// Supprime la classe après l'animation pour pouvoir la rejouer à chaque clic
		setTimeout(() => {
			button.classList.remove("clicked");
		}, 750); // Doit correspondre à la durée de l'animation CSS (0.35s)
	});
});

if (!isMobile) {
	// Debounce pour éviter de relancer trop souvent Lenis
	let lenisTimeout;
	const observer = new MutationObserver((mutationsList, observer) => {
		if (lenisTimeout) clearTimeout(lenisTimeout);
		lenisTimeout = setTimeout(() => {
			if (!lenisShouldBeStopped) {
				startLenis();
			}
		}, 200); // 200ms après la dernière mutation
	});

	observer.observe(document.body, { childList: true, subtree: true });
}

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	if (!isMobile) {
		startLenis();
	}
});